import { useComplaintsContext } from '../../../contexts/ComplaintsContext';

const useComplaintsNotificationConnector = () => {
  return {
    complaintsContext: useComplaintsContext(),
  };
};

export default useComplaintsNotificationConnector;
